import { render, staticRenderFns } from "./sample-decoration-heading-style.vue?vue&type=template&id=8f198e6c&"
import script from "./sample-decoration-heading-style.vue?vue&type=script&lang=js&"
export * from "./sample-decoration-heading-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports